import {
  types,
  ICapability,
  ICreateCapabilityAction,
  ICreateCapabilitySuccessAction,
  IFailureAction,
  IGetCapabilityByIdAction,
  IGetCapabilityByIdSuccessAction,
  IUpdateCapabilityAction,
  IUpdateCapabilitySuccessAction,
  IDeleteCapabilityAction,
  IDeleteCapabilitySuccessAction,
} from '../types/capability'

export const createCapability = (
  capabilityData: ICapability
): ICreateCapabilityAction => ({
  type: types.CREATE_CAPABILITY__STARTED,
  capabilityData,
})

export const createCapabilitySuccess = (
  capabilityData: ICapability,
  message: string
): ICreateCapabilitySuccessAction => ({
  type: types.CREATE_CAPABILITY__SUCCESS,
  capabilityData,
  message,
})

export const createCapabilityFailure = (message: string): IFailureAction => ({
  type: types.CREATE_CAPABILITY__FAILURE,
  message,
})

export const getCapabilityById = (id: string): IGetCapabilityByIdAction => ({
  type: types.GET_CAPABILITY_BY_ID__STARTED,
  id,
})

export const getCapabilityByIdSuccess = (
  capabilityData: ICapability
): IGetCapabilityByIdSuccessAction => ({
  type: types.GET_CAPABILITY_BY_ID__SUCCESS,
  capabilityData,
})

export const getCapabilityByIdFailure = (message: string): IFailureAction => ({
  type: types.GET_CAPABILITY_BY_ID__FAILURE,
  message,
})

export const updateCapability = (
  capabilityData: ICapability
): IUpdateCapabilityAction => ({
  type: types.UPDATE_CAPABILITY__STARTED,
  capabilityData,
})

export const updateCapabilitySuccess = (
  capabilityData: ICapability,
  message: string
): IUpdateCapabilitySuccessAction => ({
  type: types.UPDATE_CAPABILITY__SUCCESS,
  capabilityData,
  message,
})

export const updateCapabilityFailure = (message: string): IFailureAction => ({
  type: types.UPDATE_CAPABILITY__FAILURE,
  message,
})

export const deleteCapability = (id: string): IDeleteCapabilityAction => ({
  type: types.DELETE_CAPABILITY__STARTED,
  id,
})

export const deleteCapabilitySuccess = (
  message: string
): IDeleteCapabilitySuccessAction => ({
  type: types.DELETE_CAPABILITY__SUCCESS,
  message,
})

export const deleteCapabilityFailure = (message: string): IFailureAction => ({
  type: types.DELETE_CAPABILITY__FAILURE,
  message,
})
